import { BehaviorSubject, Observable } from 'rxjs';
import { InteriorObject } from 'src/app/models/interior-object.model';
import { RequestService } from 'src/app/services/request.service';
import { LayerEnum } from 'src/app/models/enums/LayerEnum';

export class ToolboxService {
  currentItem: BehaviorSubject<InteriorObject>;
  currentLayer: BehaviorSubject<number>;
  sourceHttpCall: (service: RequestService) => Observable<InteriorObject[]>;
  extractResponse: (resp: any[], caller: string) => Array<InteriorObject>;
  hideDeselectButton: boolean;
  listenToLayer: boolean;
  idToCall: number;

  getLayer(): Observable<LayerEnum> {
    return this.currentLayer.asObservable();
  }

  setLayer(val: LayerEnum): void {
    this.currentLayer.next(val);
  }

  getItem(): Observable<InteriorObject> {
    return this.currentItem.asObservable();
  }

  setItem(val: InteriorObject): void {
    this.currentItem.next(val);
  }
}
